import { render, staticRenderFns } from "./GoodsEdit.vue?vue&type=template&id=63c73912&scoped=true&"
import script from "./GoodsEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsEdit.vue?vue&type=script&lang=js&"
import style0 from "./GoodsEdit.vue?vue&type=style&index=0&id=63c73912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c73912",
  null
  
)

export default component.exports